import { useIntl } from "react-intl";

import { useNavigateToHotelsPage } from "src/utils/hooks/useNavigateToHotelsPage";
import BedSolid from "src/design-system/icons/BedSolid.svg?react";
import { sendAnalyticsInteractionEvent } from "src/analytics/sendAnalyticsEvent";
import type { AnalyticsEventCategory } from "src/analytics/analyticsEventTypes";
import messages from "../TripHotelMapPin/TripHotelMapPin.messages";
import { PanePromoButton } from "../PanePromoButton/PanePromoButton";

export function HotelsPromo({
  location,
  eventCategory = "SearchResults",
}: {
  location: string;
  eventCategory?: AnalyticsEventCategory;
}) {
  const intl = useIntl();
  const { navigateToHotels } = useNavigateToHotelsPage();

  const promoText = intl.formatMessage(messages.hotelsIn, {
    location: location,
  });
  const tagline = intl.formatMessage(messages.compare);

  return (
    <PanePromoButton
      onClick={() => {
        sendAnalyticsInteractionEvent({
          category: eventCategory,
          action: "Click:HotelPromoSingleDest",
        });
        navigateToHotels();
      }}
      promoText={promoText}
      tagline={tagline}
    >
      <BedSolid className="text-icon-primary" />
    </PanePromoButton>
  );
}
